import {
  addWebhookPOST,
  removeWebhookDELETE,
  updateWebhookPUT,
} from "./service";
import { NewWebhook } from "./types";

export default useWebhooks;

function useWebhooks(
  workspaceId: string,
  assistantId: string,
  syncAssistant: (data: any | ((prevData: any) => any)) => void,
) {
  async function addWebhook(webhook: NewWebhook, lifecycleCbs: any) {
    lifecycleCbs.init();

    const addWebhookRequest = {
      body: {
        ...webhook,
        workspaceId,
        assistantId,
      },
    };

    try {
      const response = await addWebhookPOST(addWebhookRequest);
      const data = await response.data;
      syncAssistant((prevAssistant: any) => {
        return {
          ...prevAssistant,
          webhooks: data,
        };
      });
      lifecycleCbs.success();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function removeWebhook(webhookId: string, lifecycleCbs: any) {
    lifecycleCbs.init();

    const removeWebhookRequest = {
      params: {
        workspaceId,
        assistantId,
        webhookId,
      },
    };

    try {
      const response = await removeWebhookDELETE(removeWebhookRequest);
      const data = await response.data;
      syncAssistant((prevAssistant: any) => {
        return {
          ...prevAssistant,
          webhooks: data,
        };
      });
      lifecycleCbs.success();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  async function updateWebhook(
    webhookId: string,
    webhook: NewWebhook,
    lifecycleCbs: any,
  ) {
    lifecycleCbs.init();

    const request = {
      params: {
        workspaceId,
        assistantId,
        webhookId,
      },
      body: webhook,
    };

    try {
      const response = await updateWebhookPUT(request);
      const data = await response.data;
      syncAssistant((prevAssistant: any) => {
        return {
          ...prevAssistant,
          webhooks: data,
        };
      });
      lifecycleCbs.success();
    } catch (e) {
      lifecycleCbs.error(e);
    }
  }

  return {
    addWebhook,
    removeWebhook,
    updateWebhook
  };
}
